import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FichasInformativasService } from '../../services/fichas-informativas.service';
import { FichasInformativasModel} from '../../models/ficha-informativa.model';

@Component({
  selector: 'fichas-informativas',
  templateUrl: './fichas-informativas.component.html',
  styleUrls: ['./fichas-informativas.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FichasInformativasComponent implements OnInit {

  public Seccion: FichasInformativasModel;
  public showFichas = false;
  constructor(private fichasInformativasService: FichasInformativasService) { }

  ngOnInit(){
    this.cargarFichasInformativas();
  }

  cargarFichasInformativas() {
    this.fichasInformativasService.ObtenerFichasInformativas().subscribe(data => {
      this.Seccion = data;
      this.showFichas = true;
    });
  }

}
